import { useEffect, useRef, useState } from "react";
import { Icon, Label, List, Popup } from "semantic-ui-react";
import { notificationApi } from "../api/api";

const POLL_INTERVAL_MS = 60000;

export default function NotificationBell() {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  const fetchNotifications = async () => {
    try {
      const data = await notificationApi.upcomingCheckouts();
      setNotifications(data || []);
    } catch {
      /* silent — don't disrupt the header over a transient poll failure */
    }
  };

  useEffect(() => {
    fetchNotifications();
    timerRef.current = setInterval(fetchNotifications, POLL_INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <Popup
      open={open}
      onOpen={() => {
        setOpen(true);
        fetchNotifications();
      }}
      onClose={() => setOpen(false)}
      on="click"
      position="bottom right"
      trigger={
        <span style={{ position: "relative", cursor: "pointer", marginRight: 6, display: "inline-flex" }}>
          <Icon name="bell outline" size="large" />
          {notifications.length > 0 && (
            <Label circular color="red" size="mini" floating>
              {notifications.length}
            </Label>
          )}
        </span>
      }
    >
      <Popup.Header>Checkout Reminders</Popup.Header>
      <Popup.Content style={{ maxWidth: 320, maxHeight: 320, overflowY: "auto" }}>
        {notifications.length === 0 ? (
          <div style={{ fontSize: "0.85rem", opacity: 0.6 }}>No upcoming checkouts.</div>
        ) : (
          <List divided relaxed>
            {notifications.map((n) => (
              <List.Item key={`${n.booking_id}-${n.room_number}`}>
                <List.Content>
                  <List.Header>
                    Room {n.room_number} — {n.guest_house_name}
                  </List.Header>
                  <List.Description>
                    {n.guest_name} · checkout in {n.minutes_remaining} min
                  </List.Description>
                </List.Content>
              </List.Item>
            ))}
          </List>
        )}
      </Popup.Content>
    </Popup>
  );
}
